import { render, staticRenderFns } from "./Devicetemperaturehumidityecharts.vue?vue&type=template&id=36ca1c0e&scoped=true"
import script from "./Devicetemperaturehumidityecharts.vue?vue&type=script&lang=js"
export * from "./Devicetemperaturehumidityecharts.vue?vue&type=script&lang=js"
import style0 from "./Devicetemperaturehumidityecharts.vue?vue&type=style&index=0&id=36ca1c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca1c0e",
  null
  
)

export default component.exports